import {Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { BehaviorSubject, Observable, Subject, combineLatest } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import {EcommerceConnectionService} from "../../service-data/ecommerce-connection.service";
import {MediaMatcher} from "@angular/cdk/layout";
import {RoleChangeListener, StartupService} from "../../service-ui/startup.service";
import {Router} from "@angular/router";
import {LoggedInCallback} from "../../service-auth/cognito.service";
import {EcommerceConnection} from "../../../model/EcommerceConnection";
import {OrganizationService} from "../../service-data/organization.service";
import {ProductService} from "../../service-data/product.service";
import {Util} from "../../util/Util";
import {EcommerceProduct} from "../../../model/EcommerceProduct";
import {EcommerceProductService} from "../../service-data/ecommerce-product.service";
import {Product} from "../../../model/Product";
import {ProductCode} from "../csv/csv-page/ProductCode";

@Component({
  selector: 'app-ecommerce-products',
  templateUrl: './ecommerce-products.component.html',
  styleUrls: ['./ecommerce-products.component.css']
})
export class EcommerceProductsComponent implements OnInit, OnDestroy, LoggedInCallback, AfterViewInit, RoleChangeListener {
  @ViewChild('summaryElement') summaryElement: ElementRef;
  @ViewChild('filterButtonsElement') filterButtonsElement: ElementRef;
  @ViewChild('searchInput') searchInput: any;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  protected readonly Util = Util;

  onDestroySubject: Subject<boolean> = new Subject();

  showSymbolMeanings: boolean = true;

  ecommerceConnections: EcommerceConnection[] = [];
  selectedEcommerceConnection: EcommerceConnection | null = null;
  selectedEcommerceConnectionId: string = 'ALL';

  ecommerceProducts: EcommerceProduct[] = [];
  products: Product[] = [];
  unmatchedEcommerceProducts: BehaviorSubject<EcommerceProduct[]> = new BehaviorSubject([]);
  selectedEcommerceProduct: EcommerceProduct | null = null;

  filteredProducts$: Observable<EcommerceProduct[]>;
  dataSource: MatTableDataSource<EcommerceProduct>;
  displayedColumns: string[] = ['id', 'ecommerceConnection', 'remoteProduct', 'product', 'remoteChangeType', 'remoteUpdateStatus', 'remoteTimestamp', 'changeType', 'updateStatus', 'updateTimestamp', 'details', 'actions'];

  // Filter state
  selectedFilters: BehaviorSubject<string[]> = new BehaviorSubject(['All']);
  searchQuery: BehaviorSubject<string> = new BehaviorSubject('');
  selectedEcommerceConnectionSubject: BehaviorSubject<EcommerceConnection | undefined> = new BehaviorSubject(undefined);

  private ngUnsubscribe = new Subject<void>();

  // Product Selection
  itemSelectionData: ProductCode | undefined = undefined;
  productsInSelectedEcommerceConnection: Product[] = [];
  filteredProductsInSelectedEcommerceConnection: Product[] = [];
  productsLoaded: boolean = false;

  selectProduct: boolean = false;
  compareProductListingDetails: boolean = false;


  constructor(private changeDetector: ChangeDetectorRef, public router: Router, public startupService: StartupService, public productService: ProductService, public organizationService: OrganizationService, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher, private ecommerceProductService: EcommerceProductService, private ecommerceConnectionService: EcommerceConnectionService) {
    this.startupService.addRoleChangeListener(this);
    this.mobileQuery = media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }

  roleChanged(role: string, roleId: string): void {
    this.getData();
  }

  ngAfterViewInit(): void {
    this.getData();
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      this.router.navigate(['/home/login']);
    } else {
      this.getData();
    }
  }

  getData(): void {
    this.selectedEcommerceConnection = undefined;
    this.selectedEcommerceConnectionSubject.next(undefined);
    this.ecommerceConnections = [];
    this.startupService.touchLastUserActivity();
    this.ecommerceConnectionService.getAddNotifier(true).pipe(takeUntil(this.onDestroySubject)).subscribe( o => {
      this.addUpdate(o);
    });
    this.ecommerceConnectionService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe( o => {
      this.addUpdate(o);
    });
    this.ecommerceConnectionService.getDeleteNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe( o => {
    });

    this.ecommerceProducts = [];
    this.ecommerceProductService.getAddNotifier(true).pipe(takeUntil(this.onDestroySubject)).subscribe( o => {
      this.addUpdateEcommerceProduct(o);
    });
    this.ecommerceProductService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe( o => {
      this.addUpdateEcommerceProduct(o);
    });
    this.ecommerceProductService.getDeleteNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe( o => {
    });

    this.products = [];
    this.productService.getAddNotifier(true).pipe(takeUntil(this.onDestroySubject)).subscribe( p => {
      this.addUpdateProduct(p);
    });
    this.productService.getUpdateNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe( p => {
      this.addUpdateProduct(p);
    });
    this.ecommerceProductService.getDeleteNotifier().pipe(takeUntil(this.onDestroySubject)).subscribe( p => {
    });
  }
  // contains(object: EcommerceConnection, array: EcommerceConnection[] ): boolean {
  //   for ( const o of array ) {
  //     if ( o.getId() === object.getId() ) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  addUpdate(o: EcommerceConnection) {
    try {
      if ( this.match(o) ) {
        if ( this.ecommerceConnections.findIndex(item => item.getId() === o.getId()) === -1) {
          this.ecommerceConnections.push(o);
        }
      }
    } catch ( e ) {
      console.log(`ERROR in EcommerceProductsComponent addUpdate ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  match(ecommerceConnection: EcommerceConnection ): boolean {
    if ( ecommerceConnection && ecommerceConnection.state === 'ACTIVE' ) {
      return true;
    }
    return false;
  }

  addUpdateEcommerceProduct(o: EcommerceProduct) {
    try {
      if ( this.matchEcommerceProduct(o) ) {
        if ( this.ecommerceProducts.findIndex(item => item.getId() === o.getId()) === -1) {
          this.ecommerceProducts.push(o);
        }
      }
    } catch ( e ) {
      console.log(`ERROR in EcommerceProductsComponent addUpdate ${o.getId()} ${e.message} ${this.startupService.selectedRole}:${this.startupService.selectedRoleId}`);
    }
  }

  matchEcommerceProduct(ecommerceProduct: EcommerceProduct ): boolean {
    if ( ecommerceProduct ) {
      return true;
    }
    return false;
  }

  addUpdateProduct(product: Product) {
    try {
      if ( this.products.findIndex(p => p.getId() === product.getId()) === -1) {
        this.products.push(product);
      }
    } catch ( e ) {
      console.log(`ERROR in EcommerceProductsComponent addUpdateProduct ${product.getId()} ${e.message}`);
    }
  }

  ngOnInit(): void {
    this.startupService.isAuthenticated(this);
    this.getData();
    this.selectedFilters.next(['ALL']);
    this.filteredProducts$ = combineLatest([
      new BehaviorSubject(this.ecommerceProductService.objects.filter(ecommerceProduct => {
        if (this.selectedEcommerceConnection ) {
          if ( ecommerceProduct.ecommerceconnection_ID === this.selectedEcommerceConnection.ID ) {
            return true;
          } else {
            return false;
          }
        }
        return true; // No filter by ecommerceConnection.ID if there is not a selected one
      })).asObservable(),
      // this.getEcommerceProductsForEcommerceConnection(this.selectedEcommerceConnection),
      this.selectedFilters,
      this.searchQuery,
      this.selectedEcommerceConnectionSubject,
      this.unmatchedEcommerceProducts
      // ,
      // this.ecommerceProductService.addNotifier,
      // this.ecommerceProductService.updateNotifier,
      // this.ecommerceProductService.deleteNotifier
    ]).pipe(
      // map(([ecommerceProducts, filters, query, addNotifier, updateNotifier, deleteNotifier]) => {
      map(([ecommerceProducts, filters, query, selectedEcommerceConnectionX, unmatchedEcommerceProducts]) => {
        // let filtered = ecommerceProducts;
        const ecommerceConnectionId = (this.selectedEcommerceConnection ? this.selectedEcommerceConnection.ID : 0);
        let filtered = ecommerceProducts; // ecommerceProducts.filter(ecommerceProduct => ecommerceProduct.ecommerceconnection_ID === ecommerceConnectionId );
        filtered = filtered.concat(unmatchedEcommerceProducts);
        if ( ecommerceConnectionId !== 0 ) {
          filtered = filtered.filter( order => {
            if ( order.ecommerceconnection_ID === ecommerceConnectionId ) {
              return true;
            }
            return false;
          });
        }

        if (!filters.includes('ALL')) {
          filtered = filtered.filter(ecommerceProduct => {
            let keep = false;
            if ( filters.includes('ERROR') && ecommerceProduct.ignoreStatus === 'NOT_IGNORE' ) {
              if ( ecommerceProduct.remoteUpdateStatus === 'ERROR') {
                keep = true;
              }
            }
            if ( filters.includes('ARCHIVED_PRODUCT') && ecommerceProduct.ignoreStatus === 'NOT_IGNORE' ) {
              if ( ecommerceProduct.productStatus === 'ARCHIVED' ) {
                keep = true;
              }
            }
            if ( filters.includes('NEED_REMOTE_PRODUCT') && ecommerceProduct.ignoreStatus === 'NOT_IGNORE' ) {
              if ( ecommerceProduct.remoteproduct_ID === '' ) {
                keep = true;
              }
            }
            if ( filters.includes('NEED_PRODUCT') && ecommerceProduct.ignoreStatus === 'NOT_IGNORE' ) {
              if ( ecommerceProduct.product_ID === 0 ) {
                keep = true;
              }
            }
            if ( filters.includes('CONNECTED') && ecommerceProduct.ignoreStatus === 'NOT_IGNORE' ) {
              if ( ecommerceProduct.remoteproduct_ID !== '' && ecommerceProduct.product_ID !== 0 && ecommerceProduct.remoteUpdateStatus !== 'ERROR') {
                keep = true;
              }
            }
            if ( filters.includes('IGNORED') ) {
              if ( ecommerceProduct.ignoreStatus === 'IGNORE') {
                keep = true;
              }
            }
            return keep;
          });
        } else { // Take the IGNORED ones out of All
          filtered = filtered.filter(order => {
            if ( order.ignoreStatus === 'IGNORE') {
                return false;
            }
            return true;
          });
        }

        if (query) {
          const lowerCaseQuery = query.toLowerCase();
          filtered = filtered.filter(ecommerceProduct =>
            ecommerceProduct?.remoteTitle?.toLowerCase().includes(lowerCaseQuery) ||
            ecommerceProduct?.product?.title?.toLowerCase().includes(lowerCaseQuery) ||
            ecommerceProduct?.product?.subtitle?.toString().toLowerCase().includes(lowerCaseQuery) ||
            String(ecommerceProduct?.remoteproduct_ID).toLowerCase().includes(lowerCaseQuery) ||
            String(ecommerceProduct?.product_ID).toLowerCase().includes(lowerCaseQuery) ||
            String(ecommerceProduct?.ID).toLowerCase().includes(lowerCaseQuery)
          );
        }
        return filtered;
      })
    );

    this.filteredProducts$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(ecommerceProducts => {
      this.dataSource = new MatTableDataSource(ecommerceProducts);
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.onDestroySubject.next(true);
    this.onDestroySubject.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onEcommerceConnectionChange(ecommerceConnection: EcommerceConnection): void {
    this.selectedEcommerceConnection = ecommerceConnection;
    this.selectedEcommerceConnectionId = ecommerceConnection ? '' + ecommerceConnection.ID : 'ALL';
    this.productsLoaded = false;
    this.productsInSelectedEcommerceConnection = [];
    this.selectedEcommerceConnectionSubject.next(this.selectedEcommerceConnection);
    if ( this.selectedEcommerceConnection || this.ecommerceConnections.length <= 1 ) {
      this.displayedColumns = ['id', 'remoteProduct', 'product', 'remoteChangeType', 'remoteUpdateStatus', 'remoteTimestamp', 'changeType', 'updateStatus', 'updateTimestamp', 'details', 'actions'];
    } else {
      this.displayedColumns = ['id', 'ecommerceConnection', 'remoteProduct', 'product', 'remoteChangeType', 'remoteUpdateStatus', 'remoteTimestamp', 'changeType', 'updateStatus', 'updateTimestamp', 'details', 'actions'];
    }
    this.showUnpublishedProducts();
  }

  onStoreSelectChange(value: string): void {
    this.selectedEcommerceConnectionId = value;
    if (value === 'ALL') {
      this.onEcommerceConnectionChange(null);
    } else {
      const found = this.ecommerceConnections.find(ec => '' + ec.ID === value);
      this.onEcommerceConnectionChange(found || null);
    }
  }

  toggleFilter(filter: string): void {
    const current = [...this.selectedFilters.value];
    if (filter === 'ALL') {
      this.selectedFilters.next(['ALL']);
    } else {
      const withoutAll = current.filter(f => f !== 'ALL');
      const idx = withoutAll.indexOf(filter);
      if (idx > -1) {
        withoutAll.splice(idx, 1);
      } else {
        withoutAll.push(filter);
      }
      this.selectedFilters.next(withoutAll.length > 0 ? withoutAll : ['ALL']);
    }
  }

  onFilterChange(event: MatButtonToggleChange): void {
    const currentFilters = [...this.selectedFilters.value];
    const changedValue = event.value as string[];

    if ((!(currentFilters.includes('ALL')) && changedValue.includes('ALL') ) || changedValue.length === 0 ) {
      this.selectedFilters.next(['ALL']);
    } else {
      const allIndex = currentFilters.indexOf('ALL');
      if (allIndex > -1) {
        changedValue.splice(allIndex, 1);
      }
      this.selectedFilters.next(changedValue);
    }
  }

  onSearchInputChange(event: Event): void {
    const query = (event.target as HTMLInputElement).value;
    this.searchQuery.next(query);
  }

  getRowBackgroundColor(ecommerceProduct: EcommerceProduct): string {
    if ( ecommerceProduct.remoteUpdateStatus === 'ERROR') {
      return 'pink';
    }
    if ( ecommerceProduct.product_ID === 0 ) {
      return '#FAD5A5';
    }
    if ( ecommerceProduct.remoteproduct_ID === '' ) {
      return 'lightyellow';
    }
    if ( ecommerceProduct.remoteUpdateStatus === 'WAITING') {
      return 'darkgrey';
    }
    if ( ecommerceProduct.remoteUpdateStatus === 'SENT') {
      return 'lightgreen';
    }
    if ( ecommerceProduct.remoteUpdateStatus === 'RECEIVED') {
      return 'lightblue';
    }
  }

  publishToRemoteServer(ecommerceProduct: EcommerceProduct, event: any): void {
    event.stopPropagation();
    const element = event.target as HTMLInputElement;
    if ( ecommerceProduct.product_ID ) {
      // Push a new remote product
      element.classList.add('spinner');
      this.ecommerceProductService.updateRemoteProduct(ecommerceProduct).subscribe(e => { // TODO: Change to the real function
        if ( e && e.remoteproduct_ID ) {
          ecommerceProduct.remoteproduct_ID = e.remoteproduct_ID;
          ecommerceProduct.remoteUpdateStatus = e.remoteUpdateStatus;
          ecommerceProduct.remoteChangeType = e.remoteChangeType;
        }
        element.classList.remove('spinner');
        console.log('compute');
      });
    }
  }

  setIgnoretatus(ecommerceProduct: EcommerceProduct, status: string, event: Event): void {
    const element: any = event.target;
    event.stopPropagation();
    element.classList.add('spinner');
    ecommerceProduct.ignoreStatus = status;
    this.ecommerceProductService.updateItem(ecommerceProduct).subscribe(e => {
      element.classList.remove('spinner');
      console.log('published product');
    });
  }

  setProduct(ecommerceProduct: EcommerceProduct, product: Product, element: any): void {
    element.classList.add('spinner');
    ecommerceProduct.product_ID = product.ID;
    ecommerceProduct.product = product;
    this.ecommerceProductService.updateItem(ecommerceProduct).subscribe(e => {
      element.classList.remove('spinner');
      // TODO: DO we look for products in other orders that need the same match?
      console.log('set product');
    });
  }

  toggleExpandCollapse(ecommerceProduct: EcommerceProduct): void {
    if ( ecommerceProduct === this.selectedEcommerceProduct ) {
      this.selectedEcommerceProduct = null;
    } else {
      this.selectedEcommerceProduct = ecommerceProduct;
      this.startProductEdit();
    }
  }

  showUnpublishedProducts() {
    if ( this.selectedEcommerceConnection && this.selectedEcommerceConnection.type !== 'CSV') {
      const productsInOrgOfEcommerceConnection: Product[] = [];
      for ( const product of this.products ) {
        if ( product.org_ID === this.selectedEcommerceConnection.org_ID && product.archived === 'FALSE' && product.isProof === 'FALSE'  ) {
          productsInOrgOfEcommerceConnection.push( product );
        }
      }
      const ecommerceProductsInEcommerceConnection: EcommerceProduct[] = [];
      for ( const ecommerceProduct of this.ecommerceProducts ) {
        if ( ecommerceProduct.ecommerceconnection_ID === this.selectedEcommerceConnection.ID ) {
          ecommerceProductsInEcommerceConnection.push( ecommerceProduct );
        }
      }

      const unmatchedEcommerceProductsToAdd = [];
      for ( let i = 0; i < productsInOrgOfEcommerceConnection.length; i++ ) {
        let found = false;
        const product = productsInOrgOfEcommerceConnection[i];
        for ( let j = 0; j < ecommerceProductsInEcommerceConnection.length && !found; j++ ) {
          const ecommerceProduct = ecommerceProductsInEcommerceConnection[j];
          if ( ecommerceProduct.product_ID === product.ID ) {
            found = true;
          }
        }
        if ( !found) {
          const unmatchedEcommerceProduct = new EcommerceProduct({ product_ID: product.ID, product: product, ecommerceconnection_ID: this.selectedEcommerceConnection.ID });
          unmatchedEcommerceProduct['AddedAsUnmatched'] = true;
          unmatchedEcommerceProduct.product = product;
          unmatchedEcommerceProduct.ecommerceConnection = this.selectedEcommerceConnection;
          unmatchedEcommerceProductsToAdd.push( unmatchedEcommerceProduct);
          console.log(`In showUnpublishedProducts adding ProductId[${product.ID}] Title[${product.title}]`);
        }
      }
      this.unmatchedEcommerceProducts.next(unmatchedEcommerceProductsToAdd);
    } else {
      this.unmatchedEcommerceProducts.next([]);
    }
  }

  readRemoteProducts(event: any) {
    if ( this.selectedEcommerceConnection && this.selectedEcommerceConnection.type !== 'CSV' ) { // TODO: have the ecommerceConnecton identify if products can be read
      const element: any = event.target;
      event.stopPropagation();
      element.classList.add('spinner');
      this.ecommerceConnectionService.readProducts(this.selectedEcommerceConnection).subscribe(e => {
        element.classList.remove('spinner');
        console.log('published product');
      });
    }
  }

  loadProductsAndEcommerceProducts() {
    if ( this.selectedEcommerceConnection && this.selectedEcommerceConnection.type !== 'CSV' ) {
      if (!this.productsLoaded) {
        const orgId = this.selectedEcommerceConnection.org_ID;
        this.productService.getFilteredItems({ eq: { 'product.org_ID': orgId, 'product.archived': 'FALSE', 'product.isProof': 'FALSE' }}, false).subscribe(products => {
          // `getFilteredItems` returns the service-wide accumulated cache, not the
          // rows matching the filter -- and with `reset: false` on an already-loaded
          // service it never sends the filter at all. Under the `network` role that
          // cache spans organizations, so the requested scope is re-applied here or
          // another org's catalog shows up in this connection's product picker.
          this.productsInSelectedEcommerceConnection = ( products || [] ).filter( product =>
            Number(product.org_ID) === Number(orgId)
            && String(product.archived) !== 'TRUE'
            && String(product.isProof) !== 'TRUE' );
          this.filteredProductsInSelectedEcommerceConnection = this.productsInSelectedEcommerceConnection.slice();
          this.productsLoaded = true;
        });
      }
    }
  }

  // Select and save a Product -- initially copied from ecommerce-order-details.component.ts
  startProductEdit(): void {
    this.loadProductsAndEcommerceProducts();

    if ( this.selectedEcommerceProduct ) {
      this.productsInSelectedEcommerceConnection = [];
      for ( const product of this.products ) {
        if ( product.org_ID === this.selectedEcommerceProduct?.ecommerceConnection?.org_ID && product.archived === 'FALSE' ) {
          this.productsInSelectedEcommerceConnection.push(product);
        }
      }
      this.filteredProductsInSelectedEcommerceConnection = this.productsInSelectedEcommerceConnection.slice();

      let title = this.selectedEcommerceProduct.remoteTitle;
      if ( this.selectedEcommerceProduct.product?.title ) {
        title = this.selectedEcommerceProduct.product.title;
      }
      this.itemSelectionData = new ProductCode(title, this.products);
      if ( this.selectedEcommerceProduct.product_ID && this.selectedEcommerceProduct.product?.archived === 'FALSE' ) {
        this.itemSelectionData.setProduct(this.selectedEcommerceProduct.product);
      }
    }
  }

  saveProductEdit(ecommerceProduct: EcommerceProduct, element: any): void {
    if ( this.selectedEcommerceProduct ) {
      if (this.itemSelectionData.product_ID !== this.selectedEcommerceProduct.product?.ID) {
        element.classList.add('spinner');
        this.selectedEcommerceProduct.product_ID = this.itemSelectionData.product_ID;
        this.selectedEcommerceProduct.product = this.itemSelectionData.product;
        this.ecommerceProductService.updateItem(ecommerceProduct).subscribe(newEcommerceProduct => {
          console.log(`Ecommerce Product updated in saveProductEdit`);
          element.classList.remove('spinner');
          this.selectedEcommerceProduct = undefined;
        });
      }
    }
  }

  cancelProductEdit(ecommerceProduct: EcommerceProduct): void {
    // Reset the itemSelectionData
  }

  get isProductEditDirty(): boolean {
    return this.selectedEcommerceProduct && this.itemSelectionData && this.itemSelectionData.product && this.selectedEcommerceProduct.product_ID !== this.itemSelectionData.product?.ID;
  }

  getBackgroundColor(intensity: number) {
    if ( intensity === 1.0) {
      return 'rgb(0, 128, 0)';
    }
    if ( intensity > 0.6 ) {
      return 'rgb(240, 240, 0)';
    }
    if ( intensity > 0.3 ) {
      return 'rgb(240, 128, 0)';
    }
    return 'rgb(240, 0, 0)';
  }
  getColor(intensity: number) {
    if ( intensity === 1.0) {
      return 'white';
    }
    if ( intensity > 0.6 ) {
      return 'black';
    }
    if ( intensity > 0.3 ) {
      return 'black';
    }
    return 'black';
  }

  onSearch(value: string) {
    const filterValue = value.toLowerCase();
    this.filteredProductsInSelectedEcommerceConnection = this.productsInSelectedEcommerceConnection.filter(product =>
      product.title.toLowerCase().includes(filterValue)
    );
  }

  clearSearch(event: Event) {
    event.stopPropagation(); // Prevents the dropdown from closing
    this.searchInput.value = '';
    this.onSearch('');
  }

  getProductObjectFromRaw(selectedEcommerceProduct: EcommerceProduct) {
    const productFromRaw = new Product(undefined);
    if ( selectedEcommerceProduct && selectedEcommerceProduct.ecommerceConnection && selectedEcommerceProduct.remoteproduct_ID && selectedEcommerceProduct.rawRemoteProduct ) {
      switch (selectedEcommerceProduct.ecommerceConnection.type ) {
        case "SHOPIFY": {
          if ( selectedEcommerceProduct.rawRemoteProduct ) {
            try {
              const raw = JSON.parse(selectedEcommerceProduct.rawRemoteProduct);
              productFromRaw.title = raw['title'] ? raw['title'] : ''; ;
              productFromRaw.description = raw['body_html'] ? raw['body_html'] : ''; ;
              productFromRaw.productWeight = raw['variants'] && raw['variants'][0] ? raw['variants'][0]['weight'] : ''; ;
              productFromRaw.customerProduct_ID = raw['variants'] && raw['variants'][0] && raw['variants'][0]['sku'] ? raw['variants'][0]['sku'] : ''; ;
              productFromRaw.msrp = raw['variants'] && raw['variants'][0] && raw['variants'][0]['price'] ? raw['variants'][0]['price'] : ''; ;
              productFromRaw.msrpCurrency = 'USD';

            } catch ( e ) {
              console.log(`Error converting SHOPIFY ecommerceProductId[${selectedEcommerceProduct.ID}] raw product data [selectedEcommerceProduct.rawRemoteProduct] into an object`);
            }
          }
          break;
        }
        case "WOOCOMMERCE": {
          if ( selectedEcommerceProduct.rawRemoteProduct ) {
            try {
              const raw = JSON.parse(selectedEcommerceProduct.rawRemoteProduct);
              if ( raw['name'] ) {
                productFromRaw.title = raw['name'];
              }
            } catch ( e ) {
              console.log(`Error converting WOOCOMMERCE ecommerceProductId[${selectedEcommerceProduct.ID}] raw product data [selectedEcommerceProduct.rawRemoteProduct] into an object`);
            }
          }
          break;
        }
      }
    }
    return productFromRaw;
  }
}
